export default "__VITE_ASSET__DOo359ck__"